import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Region Name',
    field: 'regionName',
    width: LIST_WIDTH.md,
  },
  { headerName: 'Manager', field: 'manager', width: LIST_WIDTH.md },
  {
    headerName: 'Num Of Security Companies',
    field: 'noOfSecurityCompany',
    width: LIST_WIDTH.md,
  },
  { headerName: 'Num Of Zone', field: 'noOfZone', width: LIST_WIDTH.sm },
  {
    headerName: 'Num of Guard',
    field: 'noOfGuard',
    width: LIST_WIDTH.sm,
  },
  {
    headerName: 'Num of Responder',
    field: 'noOfResponder',
    width: LIST_WIDTH.sm,
  },
  {
    headerName: 'Risk Level',
    field: 'riskLevel',
    width: LIST_WIDTH.sm,
  },
  {
    headerName: 'Currency',
    field: 'currency',
    width: LIST_WIDTH.sm,
  },
  {
    headerName: 'Default Security Company',
    field: 'defaultSecurityCompanyName',
    width: LIST_WIDTH.sm,
  },
];
